(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-page').forEach((root) => {
    const nav = root.querySelector('[data-faq-nav]');
    const navList = root.querySelector('[data-faq-nav-list]');
    const categories = root.querySelectorAll('.faq-category[id]');

    if (!nav || !navList || !categories.length) {
      if (nav) nav.hidden = true;
      return;
    }

    categories.forEach((category) => {
      const headingEl = category.querySelector('.faq-category__heading');
      if (!headingEl) return;

      const item = document.createElement('li');
      item.className = 'faq-page__nav-item';

      const link = document.createElement('a');
      link.className = 'faq-page__nav-link';
      link.href = `#${category.id}`;
      link.textContent = headingEl.textContent.trim();
      link.setAttribute('data-faq-nav-link', '');

      item.appendChild(link);
      navList.appendChild(item);
    });

    const links = navList.querySelectorAll('[data-faq-nav-link]');
    if (!links.length || !('IntersectionObserver' in window)) return;

    const setActive = (id) => {
      links.forEach((link) => {
        link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
      });
    };

    setActive(categories[0].id);

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visible.length) {
          setActive(visible[0].target.id);
        }
      },
      { rootMargin: '-15% 0px -70% 0px' }
    );

    categories.forEach((category) => observer.observe(category));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
